import script from "./UploadedFileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadedFileCard.vue?vue&type=script&setup=true&lang=js"

import "./UploadedFileCard.vue?vue&type=style&index=0&id=74307ac2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74307ac2"]])

export default __exports__